import { useEffect, useState } from "react";
import { StyledSpan } from "../../styles";
import { Modal } from "@material-ui/core";
import useCurrentBrand from 'Hooks/useCurrentBrand';
import { Container } from "modules/Sty";
import EditBrandSlugModal from "pages/MarketingPage/Components/Modals/AdminEditBrandSlugModal";
import { ShowFacebookInfo } from "pages/MarketingPage/Components/Modals/AdminShowFacebookInfo";
import useCurrentUser from 'Hooks/useCurrentUser';
import ButtonSymphony from "elements/ButtonSymphony";
import { StyledLabelP } from "modules/Sty";
import { useFacebookConnections } from "Hooks/useFacebookConnections";
import { useAuth0 } from "@auth0/auth0-react";
import ModalSymphony from "elements/ModalSymphony";

interface FacebookMeResponse {
    id: string,
    name: string,
    picture: {
        data: {
            url: string
        }
    }
}

const AccountTab = () => {
    const { logout } = useAuth0();
    const {
        currentUser,
        isSymphonyAdmin,
        deleteUser,
        isLoadingUser
    } = useCurrentUser()
    const {
        email,
    } = currentUser || {}

    const { currentBrand, isBrandAdmin, getBrand } = useCurrentBrand();
    const { loggedInFacebookUser, logoutFacebook: facebookLogout, loginWithFacebook } = useFacebookConnections()

    const {
        connections: brandConnections,
        affiliate_details: brandSourceDetails,
        id: brandId,
        slug: brandSlug,
        name: brandName,
    } = currentBrand || {}

    const [isEditSlugModalOpen, setIsEditSlugModalOpen] = useState(false);
    const [isShowFacebookModal, setIsShowFacebookModal] = useState(false);

    // for use with current Facebook login
    // get current user name
    const [me, setMe] = useState<FacebookMeResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingLogout, setLoadingLogout] = useState<boolean>(false);
    const [triggerFacebookLogoutEvent, setTriggerFacebookLogoutEvent] = useState(false);

    const [connectingTikTok, setConnectingTiktok] = useState(false);
    const [isConfirmDeleteAccountModalOpen, setIsConfirmDeleteAccountModalOpen] = useState<boolean>(false);

    // const reRequestPermissions = async () => {
    //   await loginWithFB(("rerequest" as any), "pages_show_list,pages_read_engagement")
    //   await checkFBConnectionStatus()
    // }

    // const confirmFacebookLogout = async () => {
    //   setLoadingLogout(true);
    //   try {
    //     await facebookLogout();
    //     await Axios.put(`/brand/${brandSlug}/disconnect`, {
    //       id: brandId,
    //       name: brandName,
    //       service: 'facebook'
    //     })
    //     setMe(null)
    //     loggedInFb()
    //     getBrand()
    //   } catch (error) {
    //     console.error('Error during Facebook logout:', error)
    //   } finally {
    //     setLoadingLogout(false)
    //     setTriggerFacebookLogoutEvent(false)
    //   }
    // }

    const [tiktokUser, setTikTokUser] = useState<any>(brandConnections && brandConnections.tiktok_business ? brandConnections.tiktok_business : null);

    const loginWithTikTok = () => {
        setConnectingTiktok(true)
        window.open(`https://ads.tiktok.com/marketing_api/auth?app_id=7190203583793463298&state=${brandSlug}&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Fapi%2Fbrand%2Ftiktok-connect&rid=6jj75ldezg4`,
            '_blank' // <- This is what makes it open in a new window.
        )
    }

    const handleClickLogoutButton = () => {
        logout({
            returnTo: `${window.location.origin}`
        });
    }

    const handleClickDeleteAccount = () => {
        setIsConfirmDeleteAccountModalOpen(true)
    }

    const handleConfirmDeleteAccount = async () => {
        const userId = currentUser?.id
        if (!userId) {
            return
        }
        await deleteUser(userId)
        logout({
            returnTo: `${window.location.origin}`
        });
    }

    const logoutTiktok = () => {
        setTikTokUser(null)
    }

    useEffect(() => {
        if (connectingTikTok) {
            const interval = setInterval(() => {
                console.log('This will run every 10 seconds!');
                // refresh the brand to see if user logged in
                getBrand()
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [connectingTikTok]);

    const openEditSlugModal = () => {
        setIsEditSlugModalOpen(true);
    };

    const closeEditSlugModal = () => {
        setIsEditSlugModalOpen(false);
    };

    const openFacebookModal = () => {
        setIsShowFacebookModal(true);
    }

    const closeFacebookModal = () => {
        setIsShowFacebookModal(false);
    }

    const renderAdminData = () => {
        if (!isSymphonyAdmin) {
            return null
        }

        return (
            <>
                <Container
                    className="settingsAdminDataContainer"
                    padding="0px 0px 24px 0px"
                    borderBottom="1px solid #E5E7EB"
                >
                    <StyledLabelP fontSize={20}>Admin: Brand Info</StyledLabelP>
                </Container>
                <Container padding="24px 0px" borderBottom="1px solid #E5E7EB">
                    <StyledLabelP fontSize={16}>
                        <StyledSpan color="#707070">Name:</StyledSpan>{" "}
                        <StyledSpan>{brandName}</StyledSpan>
                    </StyledLabelP>
                </Container>
                <Container padding="24px 0px" borderBottom="1px solid #E5E7EB">
                    <Container
                        display="flex" flexDirection="row" gap={"24px"}>
                        <StyledLabelP fontSize={16}>
                            <StyledSpan color="#707070">Slug / URL:</StyledSpan>{" "}
                            <StyledSpan>{brandSlug}</StyledSpan>
                            {isBrandAdmin &&
                                <Container
                                    display="flex"
                                    gap="16px"
                                    marginTop="8px"
                                    alignItems="center"
                                >
                                    <ButtonSymphony
                                        className="settingsPageEditSlugButton"
                                        onClick={openEditSlugModal}
                                        variant="text"
                                        size="small"
                                    >
                                        Edit Slug
                                    </ButtonSymphony>
                                    <ButtonSymphony
                                        className="settingsPageFacebookInfoButton"
                                        onClick={openFacebookModal}
                                        variant="text"
                                        size="small"
                                    >
                                        Facebook info
                                    </ButtonSymphony>
                                </Container>
                            }
                        </StyledLabelP>
                        <StyledLabelP fontSize={16}>
                            <StyledSpan color="#707070">Partner Affiliate Discount:</StyledSpan>{" "}
                            <StyledSpan>{brandSourceDetails ? (`${brandSourceDetails.partnerName}-driven user / ${brandSourceDetails.discountAmount * 100}% off`) : ('Not driven by partner / No Discount Enabled')}</StyledSpan>
                        </StyledLabelP>
                    </Container>
                </Container>
                {brandSlug &&
                    <EditBrandSlugModal
                        open={isEditSlugModalOpen}
                        closeModal={closeEditSlugModal}
                    />
                }
                {brandId &&
                    <ShowFacebookInfo
                        open={isShowFacebookModal}
                        closeModal={closeFacebookModal}
                        brandId={brandId}
                    />
                }
            </>
        )
    }

    return (
        <>
            <Container className="accountTabComponent">
                {renderAdminData()}
                <Container
                    padding="24px 0px 24px 0px"
                    borderBottom="1px solid #E5E7EB"
                >
                    <StyledLabelP fontSize={20}>Account</StyledLabelP>
                </Container>
                <Container padding="24px 0px" borderBottom="1px solid #E5E7EB">
                    <StyledLabelP fontSize={16}>
                        <StyledSpan color="#707070">Email:</StyledSpan>{" "}
                        <StyledSpan>{email}</StyledSpan>
                    </StyledLabelP>
                </Container>
                {isBrandAdmin &&
                    <>
                        <Container
                            margin="32px 0px 0px 0px"
                            padding="0px 0px 24px 0px"
                            borderBottom="1px solid #E5E7EB"
                        >
                            <StyledLabelP fontSize={20}>Connections</StyledLabelP>
                        </Container>
                        <Container padding="24px 0px" borderBottom="1px solid #E5E7EB">
                            <StyledLabelP fontSize={16} style={{ marginBottom: 12 }}>
                                <StyledSpan className="settingsPageFacebookLabel" color="#707070">Facebook:</StyledSpan>{" "}
                                {loggedInFacebookUser ? <StyledSpan>Logged in</StyledSpan> : "Not connected"}
                            </StyledLabelP>
                            {loggedInFacebookUser ?
                                <>
                                    <div className="md:w-2/5 mt-2 mb-4 border rounded-md p-2 flex justify-between">
                                        <div className="flex items-center">
                                            <img className="w-10 h-10 mr-2" src={loggedInFacebookUser?.picture?.data?.url} alt="Facebook Profile" />
                                            <p>{loggedInFacebookUser?.name}</p>
                                        </div>
                                        <ButtonSymphony
                                            className="facebookLogoutButton"
                                            onClick={() => {
                                                facebookLogout()
                                            }}
                                            color="red"
                                            variant="text"
                                            style={{
                                                marginRight: 12,
                                            }}
                                        >
                                            Log out
                                        </ButtonSymphony>
                                    </div>
                                    {/* <ButtonSymphony
                                    className="settingsPageLinkPagesButton"
                                    onClick={() => {

                                    }}
                                    variant="outlined"
                                    size="small"
                                    >
                                    Link Pages to Symphony &gt;
                                    </ButtonSymphony> */}
                                </>
                                :
                                <ButtonSymphony
                                    className="settingsPageConnectFacebookButton2"
                                    onClick={() => loginWithFacebook()}
                                    disabled={loading}
                                    variant="outlined"
                                >
                                    Connect Facebook
                                </ButtonSymphony>
                            }
                        </Container>
                    </>
                }
                <div
                    className="logoutDeleteButtonSettingsPageContainer"
                    style={{
                        display: 'flex', flexDirection: 'row',
                        justifyContent: 'space-between',
                        gap: 16, marginTop: 24
                    }}
                >
                    <ButtonSymphony
                        className="logoutButtonSettingsPage"
                        onClick={handleClickLogoutButton}
                        variant="outlined"
                        color="red"
                    >
                        Logout
                    </ButtonSymphony>
                    <ButtonSymphony
                        className="logoutButtonSettingsPage"
                        onClick={handleClickDeleteAccount}
                        color="grey"
                        variant="text"
                    >
                        Delete Account
                    </ButtonSymphony>
                </div>
                <Modal
                    open={triggerFacebookLogoutEvent}
                    onClose={() => setTriggerFacebookLogoutEvent(false)}
                    aria-labelledby="logout of facebook"
                    aria-describedby="popup-to-confirm facebook logout user"
                >
                    <div className="top-wrapper w-full lg:w-4/12 transform-gpu -translate-x-1/2 -translate-y-1/2 flex items-center justify-center left-1/2 top-1/2 absolute z-50 card-content bg-white shadow-none lg:shadow-lg">
                        <div className="w-full">
                            <div className="bg-white w-full h-full mx-auto">
                                <div className="flex flex-row justify-between p-6 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg">
                                    <p className="font-semibold text-gray-800">Log out of Facebook?</p>
                                    <a className="closeButtonThing7" onClick={() => setTriggerFacebookLogoutEvent(false)} href="#">
                                        <svg
                                            className="w-6 h-6"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M6 18L18 6M6 6l12 12"
                                            ></path>
                                        </svg>
                                    </a>
                                </div>
                                {/* <div className=" px-4 lg:px-10 ">
                <h4 className="mt-5 pb-5 text-2x font-semibold border-b border-gray-200">
                  If you log out of Facebook, your Instagram + Facebook will be automatically disconnected and any running ads might have issues.
                </h4>
                <div className="flex py-2">
                  {loadingLogout ?
                    <Loader />
                    :
                    <>
                      <ButtonSymphony
                        className="buttonAccountTab1"
                        onClick={() => setTriggerFacebookLogoutEvent(false)}
                        variant="outlined"
                        disabled={loadingLogout}
                        width="100%"
                      >
                        Don't Logout
                      </ButtonSymphony>
                      <ButtonSymphony
                        className="buttonAccountTab2"
                        onClick={confirmFacebookLogout}
                        variant="outlined"
                        disabled={loadingLogout}
                        width="100%"
                      >
                        Yes, Logout
                      </ButtonSymphony>
                    </>
                  }
                </div>
              </div> */}
                            </div>
                        </div>
                    </div>
                </Modal>
            </Container>

            {/* MODALS */}
            <ModalSymphony
                className="confirmDeleteAccountModal"
                isOpen={isConfirmDeleteAccountModalOpen}
                onClose={() => setIsConfirmDeleteAccountModalOpen(false)}
                title="Are you sure you want to delete your account?"
                subtitle="All of your brands and data will be removed."

                onClickButtonRight={handleConfirmDeleteAccount}
                buttonRightText="Delete Account"
                buttonRightColor="red"
                buttonRightVariant="primary"
                onClickButtonLeft={() => setIsConfirmDeleteAccountModalOpen(false)}
                buttonRightIsLoading={isLoadingUser}
                buttonRightDisabled={isLoadingUser}
                buttonRightLoadingText="Deleting account..."

                buttonLeftText="Cancel"
                buttonLeftColor="grey"
                buttonLeftVariant="outlined"
            />
        </>
    );
};

export default AccountTab;
